// Alpine
import 'alpine-turbo-drive-adapter'
import Alpine from 'alpinejs'

import { exams, exerciseGroup } from '~/alpine/exams'
Alpine.data('exams', exams)
Alpine.data('exerciseGroup', exerciseGroup)

import { feedbackDialog } from '~/alpine/feedback_dialog'
Alpine.data('feedbackDialog', feedbackDialog)

import { mainNavbar, navDropdown } from '~/alpine/navbar'
Alpine.data('mainNavbar', mainNavbar)
Alpine.data('navDropdown', navDropdown)

import { lazyLoadExercises, practiceExam, answerElement, practiceExercise, variants } from '~/alpine/practice'
Alpine.data('lazyLoadExercises', lazyLoadExercises)
Alpine.data('practiceExam', practiceExam)
Alpine.data('answerElement', answerElement)
Alpine.data('practiceExercise', practiceExercise)
Alpine.data('variants', variants)

import { takeExam, hideQuestionOverflow } from '~/alpine/take_exam'
Alpine.data('takeExam', takeExam)
Alpine.data('hideQuestionOverflow', hideQuestionOverflow)

import { imageZoom } from '~/alpine/image_zoom'
Alpine.data('imageZoom', imageZoom)

window.Alpine = Alpine
window.Alpine.start()

// Prevent right click and dragging on images for the main app
const preventImageActions = (e) => e.target.nodeName === 'IMG' && e.preventDefault()

// Listeners are attached on the document so that they also trigger on dynamically added image elements
document.addEventListener('contextmenu', preventImageActions)
document.addEventListener('dragstart', preventImageActions)
